import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, CircularProgress, Container, CssBaseline, Grid, Pagination, TextField, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import moment from "moment";
import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Footer from "src/components/footer";
import HeaderMenu from "src/components/header-menu";
import CustomizedSnackbars from "src/components/material-snackbars";
import Api from "src/services/api";
import Api2Talk from "src/services/api2talk";
import { Overlay } from "src/styles/global";
import { Styles } from "src/styles/material-styles";
import clsx from 'clsx'
import PropTypes from "prop-types"
import { AbilityContext } from "src/config/ability-context";
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import * as calledsActions from '../../redux/actions/calleds'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SimpleAutoComplete from "src/components/auto-complete/autocomplete-dialog-with-z-index";
import ApiReports from "src/services/apireport";
import MyMaterialTable from '../../components/table'
import { PapiroConsole } from "src/utils/papiroConsole";
import HeaderCard from "./components/header-card";

class SatisfactionSruveyReport extends Component {
    constructor(props) {
        super(props)

        this.isClient = true
        this.isAdm = false
        this.typingTimeout = null
        this.organizationId = null

        const { userSession } = this.props

        if (userSession == null || userSession.user == null || userSession.user.userrole == null)
            Api.logoff()

        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype != 3)
                this.isClient = false
            if (item.role.roletype == 0 || item.role.roletype == 1)
                this.isAdm = true
        });


        if (userSession.user.organization)
            this.organizationId = userSession.user.organization.id

        this.initialState = {
            resultList: [],
            activeUsers: 0,
            totalChatsAssigned: 0,
            totalClosedChats: 0,
            totalAvgNoteAssigned: 0,
            totalPercentageSurveysAnswered: 0,
        }

        this.state = {
            result: this.initialState,
            MessageProviderId: null,
            assigned: '',
            minClassification: '',
            optionsMessageProviders: [],
            dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
            dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
            organizationId: this.organizationId,
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            showGrid: false,
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchValue: '',
            showHeader: false,
            strhtmlModalOpen: false,
            dialogHTMLString: [],
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.changeValues = this.changeValues.bind(this);
    }

    handleAutocompleteChange = (name, value) => {
        this.setState({ [name]: value })
    }

    handleInputChange(e) {
        const name = e.target.name
        const value = e.target.value
        PapiroConsole.log(name)
        PapiroConsole.log(value)
        this.setState({ [name]: value })
        // if (name == 'maxClassification' && this.state.minClassification != '' && value < this.state.minClassification) {
        //     this.setState({ minClassification: value })
        // }
        // if (name == 'minClassification' && this.state.maxClassification != '' && value > this.state.maxClassification) {
        //     this.setState({ maxClassification: value })
        // }
    }

    handleChangeAutoComplete = async (stateName, value) => {
        let data = value.id > 0 ? value : null

        this.setState({
            [stateName]: data
        })
    }

    changeValues = async (stateName, value, text = '') => {
        this.setState({ [stateName]: value })
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page })
        this.getList('', page)
    }

    setPagination = (count, page) => {
        let totalPage = Math.ceil(count / 10)
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10)
                    this.setState({ pageStart: 1, pageEnd: count })
                else
                    this.setState({ pageStart: 1, pageEnd: 10 })
            } else {
                let pageStart = ((page - 1) * 10) + 1
                if (count >= page * 10)
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 })
                else
                    this.setState({ pageStart: pageStart, pageEnd: count })
            }
        } else
            this.setState({ totalPages: 0, page: 1, count: 0 })
    }

    async componentDidMount() {
        this.setState({ loading: true })
        await this.fetchOptionsMessageProvider()
        this.setState({ loading: false })
    }

    fetchDataNotSuccess(result) {
        const intl = this.props.intl
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        })
    }

    fetchDataThrowError(err) {
        const intl = this.props.intl
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        })
    }

    fetchOptionsMessageProvider = async () => {

        Api2Talk.get(`/messageprovider`)
            .then(result => {

                if (result.data.success) {
                    const messageProviderOptions = result.data.data
                    this.setState(prevState => ({
                        optionsMessageProviders: messageProviderOptions
                    }))
                } else {
                    this.fetchDataNotSuccess(result)
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({ loading: false })
                this.fetchDataThrowError(err)
                Api.kickoff(err)
            })
    }

    closeNotification = _ => {
        this.setState({ openNotification: false })
    }

    handleSubmit = async e => {
        const intl = this.props.intl
        e.preventDefault()
        this.setState({ loading: true })


        PapiroConsole.log("this.state.dateStart")
        PapiroConsole.log(this.state.dateStart)
        PapiroConsole.log("this.state.dateEnd")
        PapiroConsole.log(this.state.dateEnd)

        var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
        var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
        if (dateStart > dateEnd) {
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
                loading: false
            })
        } else if (this.state.minClassification != '' && this.state.maxClassification != '' && this.state.minClassification > this.state.maxClassification) {
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "minimum.score.cannot.be.greater.than.maximum.score" }),
                loading: false
            })
        } else {
            await this.getList(this.props.location.state)
        }
    }

    getList = async (filter = '', page = 1) => {
        const intl = this.props.intl;
        this.setState({ loading: true });

        let url = `/report/2talk-chats-classifications-performance-report/paginate?page=${page}`

        url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`
        if (this.state.MessageProviderId && this.state.MessageProviderId.id && this.state.MessageProviderId.id > 0) {
            url += `&messageProviderId=${this.state.MessageProviderId.id}`
        }
        if (this.state.assigned && this.state.assigned.length > 0)
            url += `&assignedUser=${this.state.assigned}`
        if (this.state.minClassification != null && this.state.minClassification != "")
            url += `&minclassification=${this.state.minClassification}`
        if (this.state.maxClassification != null && this.state.maxClassification != "")
            url += `&maxclassification=${this.state.maxClassification}`
        this.setState({ showGrid: true })

        ApiReports.get(url)
            .then(result => {
                if (result.data.success) {
                    let count = result.data.count
                    this.setState({ count: count })
                    this.setPagination(count, page)
                    var formattedList = result.data.data ? result.data.data.map((item) => {
                        return {
                            assignedusername: item.assignedusername,
                            chatsassigned: item.chatsassigned,
                            closedchats: item.closedchats,
                            avgnoteassigned: item.avgnoteassigned,
                            percentagesurveysanswered: item.percentagesurveysanswered ? `${item.percentagesurveysanswered}%` : 0,
                        }
                    }) : []
                    
                    if (result.data.data && result.data.data.length > 0) {
                        const summary = result.data.data[0];
                        this.setState({
                            result: {
                                resultList: formattedList,
                                activeUsers: summary.totalactiveusers ?? 0,
                                totalChatsAssigned: summary.totalchatsassignedglobal ?? 0,
                                totalClosedChats: summary.totalclosedchatsglobal ?? 0,
                                totalAvgNoteAssigned: summary.avgnoteassignedglobal ?? 0,
                                totalPercentageSurveysAnswered: summary.percentageansweredglobal ?? 0
                            }
                        });
                    }
                    this.setState({ loading: false })
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                console.log("=== Catch(e) ===")
                console.log(err)
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    getExcel = async () => {

        this.setState({ loading: true });
        var url = '/report/2talk-chats-classifications-performance-report/excel';

        url += `?dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`
        if (this.state.MessageProviderId && this.state.MessageProviderId.id && this.state.MessageProviderId.id > 0) {
            url += `&messageProviderId=${this.state.MessageProviderId.id}`
        }
        if (this.state.assigned && this.state.assigned.length > 0)
            url += `&assignedUser=${this.state.assigned}`
        if (this.state.minClassification != null && this.state.minClassification != "")
            url += `&minclassification=${this.state.minClassification}`
        if (this.state.maxClassification != null && this.state.maxClassification != "")
            url += `&maxclassification=${this.state.maxClassification}`

        await ApiReports.get(url)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
                    });
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                });
            });

        const intl = this.props.intl;

        this.setState({ loading: false });
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props
        const intl = this.props.intl
        const { activeUsers, totalChatsAssigned, totalClosedChats, totalAvgNoteAssigned, totalPercentageSurveysAnswered, resultList } = this.state.result

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />
                        <Grid container spacing={6}>
                            <Grid item xs={12} sm={12}>
                                <Card >
                                    <CardContent className="background-title-search">
                                        <Typography variant="h5">
                                            {<FormattedMessage id="2talk.satisfation.survey.report" />}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                        <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                            <Accordion >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid fullWidth container spacing={2} style={{ marginBottom: 20 }}>
                                        <Grid item xs={12} md={4} >
                                            <TextField
                                                fullWidth
                                                label={intl.formatMessage({ id: "assigned" })}
                                                inputProps={{ maxLength: 40 }}
                                                autoComplete='off'
                                                type="text"
                                                variant='outlined'
                                                name='assigned'
                                                onChange={this.handleInputChange}
                                                value={this.state.assigned}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4} >
                                            <SimpleAutoComplete
                                                name="MessageProviderId"
                                                label={intl.formatMessage({ id: "select.message_provider" })}
                                                options={this.state.optionsMessageProviders}
                                                stateName='MessageProviderId'
                                                changeSelect={(stateName, value) => {
                                                    this.handleChangeAutoComplete(stateName, value)
                                                }}
                                                selected={this.state.MessageProviderId}
                                                htmlOptions={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} >
                                            <SimpleDatePicker
                                                label={intl.formatMessage({ id: "start.date" })}
                                                name='dateStart'
                                                stateName='dateStart'
                                                changeDate={this.changeValues}
                                                currentDate={this.state.dateStart}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} >
                                            <SimpleDatePicker
                                                label={intl.formatMessage({ id: "end.date" })}
                                                name='dateEnd'
                                                stateName='dateEnd'
                                                changeDate={this.changeValues}
                                                currentDate={this.state.dateEnd}
                                                required
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} >
                                            <TextField
                                                fullWidth
                                                label={intl.formatMessage({ id: "min.classification" })}
                                                autoComplete='off'
                                                type="number"
                                                variant='outlined'
                                                name='minClassification'
                                                onChange={this.handleInputChange}
                                                value={this.state.minClassification}
                                                InputProps={{ inputProps: { min: 0, max: 10 } }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} >
                                            <TextField
                                                fullWidth
                                                label={intl.formatMessage({ id: "max.classification" })}
                                                autoComplete='off'
                                                type="number"
                                                variant='outlined'
                                                name='maxClassification'
                                                onChange={this.handleInputChange}
                                                value={this.state.maxClassification}
                                                InputProps={{ inputProps: { min: 0, max: 10 } }}
                                            />
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            <Grid container style={{ marginBottom: 10 }}>
                                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                                    <Button
                                        type='submit'
                                        fullWidth
                                        variant='contained'
                                        color='secondary' >
                                        {<FormattedMessage id="filter" />}
                                    </Button>
                                </Grid>
                                {this.state.showGrid && <Grid item xs={6} sm={5} md={2} style={{ marginTop: 10, marginRight: 10 }}>
                                    <Button
                                        fullWidth
                                        variant='contained'
                                        color='primary'
                                        onClick={this.getExcel}
                                    >
                                        {<FormattedMessage id="export.plan" />}
                                    </Button>
                                </Grid>}
                            </Grid>
                        </form>
                        {
                            this.state.showGrid && <>
                                <Grid container justifyContent="space-around" marginTop={1} marginBottom={3}>
                                    {activeUsers != null && <HeaderCard title={<FormattedMessage id="active.users" />} value={activeUsers} />}
                                    {totalChatsAssigned != null && <HeaderCard title={<FormattedMessage id="total.chats.assigned" />} value={totalChatsAssigned} />}
                                    {totalClosedChats != null && <HeaderCard title={<FormattedMessage id="total.responses" />} value={totalClosedChats} />}
                                    {totalAvgNoteAssigned != null && <HeaderCard title={<FormattedMessage id="total.avg.note.assigned" />} value={totalAvgNoteAssigned} />}
                                    {totalPercentageSurveysAnswered != null && <HeaderCard title={<FormattedMessage id="total.percentage.surveys.answered" />} value={totalPercentageSurveysAnswered ? `${totalPercentageSurveysAnswered}%` : 0} />}
                                </Grid>
                                <MyMaterialTable
                                    title=""
                                    columns={
                                        [
                                            { title: intl.formatMessage({ id: "assigned" }), field: 'assignedusername' },
                                            { title: intl.formatMessage({ id: "chats.assigned" }), field: 'chatsassigned' },
                                            { title: intl.formatMessage({ id: "conversations.with.answered.surveys" }), field: 'closedchats' },
                                            { title: intl.formatMessage({ id: "avg.note.assigned" }), field: 'avgnoteassigned' },
                                            { title: intl.formatMessage({ id: "percentage.surveys.answered" }), field: 'percentagesurveysanswered' },
                                        ]}
                                    data={resultList} />

                                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                                    <Grid item xs={12} md={3}>
                                        <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                                    </Grid>
                                    <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                        {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {activeUsers} {<FormattedMessage id="register" />}
                                    </Grid>
                                </Grid>
                            </>
                        }
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification} />
                    </Container>
                </main>
                <Footer />
            </div>
        )
    }
}

SatisfactionSruveyReport.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(SatisfactionSruveyReport)))
SatisfactionSruveyReport.contextType = AbilityContext